<template>
  <div class="p-4 c-catalog-iq-switcher-content min-w-[270px]">
    <div class="flex justify-between items-center">
      <div class="text-center text-20px font-500 leading-32px tracking-[0.25px] ma-0">
        {{ t('canvasUI.components.CCatalogIqSwitcherContent.switchTo') }}
      </div>
    </div>
    <div class="flex flex-col mt-3">
      <a
        v-for="item in items"
        :key="item.app"
        class="c-catalog-iq-switcher-content__item flex items-center justify-between pa-2 gap-2 no-underline text-current rounded-2"
        :href="item.url"
        rel="noopener noreferrer"
        target="_blank"
        @click="emit('click')"
      >
        <div class="flex items-center gap-2">
          <img :alt="item.text" class="h-9 w-9" :src="item.svgUrl" />
          <div class="text-16px font-500 leading-24px tracking-[0.25px]">{{ item.text }}</div>
        </div>
        <CIcon icon="arrow-up-right-from-square" size="16px" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import type { Props } from './CCatalogIqSwitcher.types'
import catalogIqSvg from './CatalogIq.svg'
import catalogIqSvgAdmin from './AdminCatalogIq.svg'

const emit = defineEmits<{ click: [] }>()
const props = defineProps<Props>()
const { t } = useI18n()
const items = computed(() =>
  Object.entries(props.urls).map(([key, value]) => ({
    app: key,
    url: value,
    text:
      key === 'admin'
        ? t('canvasUI.components.CCatalogIqSwitcherContent.catalogIqAdmin')
        : t('canvasUI.components.CCatalogIqSwitcherContent.catalogIqWeb'),
    svgUrl: key === 'admin' ? catalogIqSvgAdmin : catalogIqSvg,
  })),
)
const themeVars = useThemeVars()
</script>

<style scoped lang="scss">
.c-catalog-iq-switcher-content {
  color: v-bind('themeVars.text');
  font-family: 'Roboto', sans-serif;
}

.c-catalog-iq-switcher-content__item {
  cursor: pointer;

  &:hover {
    background: v-bind('themeVars.primary6');
  }
}
</style>
